import {Component, EventEmitter, Input, Output} from '@angular/core';
import { XTabSegmentComponent } from './x-tab-segment/x-tab-segment.component';
import { NgIf } from '@angular/common';

export type XTabSegmentWithText = {
  id: string | number;
  title: string;
  disabled?: boolean;
};

export type XTabSegmentWithIcon = {
  id: string | number;
  icon: string;
  disabled?: boolean;
};
@Component({
  selector: 'app-x-tab-panel',
  standalone: true,
  imports: [XTabSegmentComponent, NgIf],
  templateUrl: './x-tab-panel.component.html',
  styleUrl: './x-tab-panel.component.less',
})
export class XTabPanelComponent {
  @Input() tabs: (XTabSegmentWithText | XTabSegmentWithIcon)[] = [];
  @Input() active: string | number = '';
  @Output() activeChange= new EventEmitter<string | number>();

  isTextTab(tab: XTabSegmentWithText | XTabSegmentWithIcon): tab is XTabSegmentWithText {
    // @ts-ignore
    return !!tab['title'];
  }

  isIconTab(tab: XTabSegmentWithText | XTabSegmentWithIcon): tab is XTabSegmentWithIcon {
    // @ts-ignore
    return !!tab['icon'];
  }

  public onTabClick(tab: XTabSegmentWithIcon | XTabSegmentWithText) {
    // Prevent click on disabled tabs
    if ('disabled' in tab && tab.disabled) {
      return;
    }
    this.activeChange.emit(tab.id);
  }
}
